export default __webpack_public_path__ + "assets/images/histAfterTopHat-5b537a01160763a88f84d87a5a2cbe12.svg";